import { GetModelsResponse } from 'services/api/embeddingModels/types';
import { dataScienceClient } from 'services/backofficeIntegration/http/client/createDataScienceClient';

const ModelsAPI = {
  getAll: () => dataScienceClient.get<unknown, GetModelsResponse>('/word-embedding/get_embedding_models')
};

export default ModelsAPI;
